// extracted by mini-css-extract-plugin
export default {"contact":"direction_contact__gkKII","title":"direction_title__+k144","fields":"direction_fields__fRLZy","field":"direction_field__LwQCD","buttons":"direction_buttons__oy8CJ"};